import { useMutation } from '@tanstack/react-query';

import { $api, errorHandler } from 'modules/global';

export function useFinishTopicTest() {
  return useMutation<unknown, unknown, number>(
    async ticketId => {
      const { data } = await $api.get('/check-test', { params: { ticket_id: ticketId } });

      return data;
    },
    {
      onError: errorHandler()
    }
  );
}
